/**
 * @desc reconFile
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(params: API.walmart.test.reconFile.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/reconFile`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
